import lazyLoading from './lazyLoading'

export default {
  name: 'HomeNet Bill Statement',
  path: '/homenet/bill',
  redirect: '/homenet/bill/statement',
  meta: {
    auth: ['user'],
    icon: 'fas fa-cube',
    expanded: false
  },
  component: lazyLoading('homenet', true),
  children: [
    {
      'name': 'Statement',
      'path': 'statement',
      'meta': {
        'label': 'Statement'
      },
      'component': lazyLoading('homenet/Bill')
    }
  ]
}



// WEBPACK FOOTER //
// ./client/store/modules/menu/bill.js